import React, { Component } from 'react';
import { ShrinkLlegendaSvg } from './LlegendaFooterIconsElement';

export class ShrinkLlegendaIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isButtonHovered: false
    };
  }

  render = () => {
    return (
      <ShrinkLlegendaSvg
        innerWidth={this.props.windowWidth}
        isHover={this.state.isButtonHovered}
        fontSizeEnabled={this.props.isFontSizeEnabled}
        onMouseEnter={() => this.setState({ isButtonHovered: true })}
        onMouseLeave={() => this.setState({ isButtonHovered: false })}>
        <path d="M100,0h312c55.2,0.1,99.9,44.8,100,100v312c-0.1,55.2-44.8,99.9-100,100H100C44.8,511.9,0.1,467.2,0,412V100  C0.1,44.8,44.8,0.1,100,0z M205.8,325c0-10.4-8.4-18.7-18.8-18.7H88.9c-10.4-0.1-18.8,8.2-18.9,18.6c-0.1,10.4,8.2,18.8,18.6,18.9  c0.1,0,0.3,0,0.4,0h52.9L72,413.5c-7.3,7.3-7.3,19.2,0,26.5s19.2,7.3,26.5,0l69.8-69.8v52.9c0.1,10.4,8.6,18.7,18.9,18.6  c10.2-0.1,18.5-8.4,18.6-18.6L205.8,325z M311.3,182c0,10.4,8.4,18.7,18.8,18.8h98.1c10.4,0.1,18.8-8.2,18.9-18.6  c0.1-10.4-8.2-18.8-18.6-18.9c-0.1,0-0.3,0-0.4,0h-52.9l69.8-69.8c7.3-7.3,7.3-19.2,0-26.5c-7.3-7.3-19.2-7.3-26.5,0l0,0l-69.8,69.8  V83.8c-0.1-10.4-8.6-18.7-18.9-18.6c-10.2,0.1-18.5,8.4-18.6,18.6V182z"></path>
      </ShrinkLlegendaSvg>
    );
  };
}
